module.exports = __webpack_public_path__ + "media/images/shape-1-6e1e54b65561deb57f9c35f2d7387567.svg";